import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

/**
 * Breadcrumbs — shows navigation context on deep pages.
 * items: [{ label: string, href?: string }]
 * The last item (current page) has no href and is styled as active.
 */
export default function Breadcrumbs({ items = [], className = '' }) {
  if (!items.length) return null;

  return (
    <nav
      className={`flex items-center gap-1 text-xs text-muted-foreground flex-wrap ${className}`}
      aria-label="Breadcrumb"
      data-testid="breadcrumbs"
    >
      <Link
        to="/"
        className="flex items-center gap-1 hover:text-[#FF4500] transition-colors flex-shrink-0"
        aria-label="Home"
      >
        <Home className="w-3 h-3" />
      </Link>

      {items.map((item, i) => (
        <React.Fragment key={i}>
          <ChevronRight className="w-3 h-3 text-muted-foreground/40 flex-shrink-0" />
          {item.href ? (
            <Link
              to={item.href}
              className="hover:text-[#FF4500] transition-colors truncate max-w-[120px] sm:max-w-[180px]"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground font-medium truncate max-w-[140px] sm:max-w-[220px]">
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
